import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { FormLabel, ReduxFormError } from 'shared';

const Container = styled.div`
    margin-bottom: 1.5rem;
    text-align: left;
    margin-top: ${(props) => (props.labelTitle ? null : '-1rem')};
`;

const ReduxFormCheckbox = ({ type, required, labelTitle, input, meta, className }) => (
    <Container {...{ labelTitle, className }}>
        {labelTitle && <FormLabel {...{ required, labelTitle }} />}
        <input type="checkbox" {...input} /> <span>{input.checked ? 'Yes' : 'No'}</span>
        <ReduxFormError {...{ meta }} />
    </Container>
);

ReduxFormCheckbox.propTypes = {
    /** This is the type attribute */
    type: PropTypes.string.isRequired,
    /** This is the placeholder attribute */
    placeholder: PropTypes.string,
    /** This is label content */
    labelTitle: PropTypes.string,
    /** This is the required attribute */
    required: PropTypes.bool,
    /** If validation fails, this should be true */
    /** This is the disabled attribute */
    disabled: PropTypes.bool,
    meta: PropTypes.any,
    input: PropTypes.any,
};

ReduxFormCheckbox.defaultProps = {
    type: 'text',
};

export default ReduxFormCheckbox;
